export { P10SearchPage as default } from './P10SearchPage';
